module.exports = __webpack_public_path__ + "media/images/user/konnavi-2fbd29d164d40a5544de74703ffbe278.svg";